<template>
  <div class='addEvent container mt-5 mb-5'>
    <h1>Manage Events</h1>
    <br>
    <b-alert v-if="!isSignedIn" variant="primary" show>
      Please log in to manage events.
    </b-alert>
    <b-alert v-if="isSignedIn && !isAuthorizedUser" variant="danger" show>
      Please login as an authorized user!
    </b-alert>
    <GoogleLogin v-if="!isSignedIn" :params="params" :onSuccess="checkAuthStatus"
      :onFailure="onFailure">
      Login
    </GoogleLogin>
    <GoogleLogin v-if="isSignedIn" :params="params" :logoutButton=true :onSuccess="checkAuthStatus">
      Logout
    </GoogleLogin>

    <div v-if="isSignedIn && isAuthorizedUser" class="mt-4">
      <div id="need-approval" v-if="needApproval.length">
        <h2>Waiting for Approval</h2>
        <ul>
          <b-list-group v-for="item in needApproval" :key="item.title">
            <b-list-group-item>
              <div class="d-flex justify-content-between align-items-center">
                <strong>{{ item.title }}</strong>
                <div>
                  <b-button class="mr-1" variant="success" :disabled="item.approved"
                    @click="approveEvent(item.id)">
                    Approve
                  </b-button>
                  <b-button variant="danger" @click="deleteEvent(item.id)">Delete</b-button>
                </div>
              </div>
              <p v-if="item.location">Location: {{ item.location }}</p>
              <p v-if="item.start">Start Date: {{ (item.start) | moment("dddd, MMMM Do YYYY") }}</p>
              <p v-if="item.start">Start Time: {{ (item.start) | moment("h:mm A") }}</p>
              <p v-if="item.end">End Date: {{ (item.end) | moment("dddd, MMMM Do YYYY") }}</p>
              <p v-if="item.end">End Time: {{ (item.end) | moment("h:mm A") }}</p>
              <p v-if="item.description">Description: {{ item.description }}</p>
              <p v-if="item.link">Event Link: <a :href="item.link">{{ item.link }}</a></p>
              <p v-if="item.name">Contact Name: {{ item.name }}</p>
              <p v-if="item.email">Contact Email: {{ item.email }}</p>
            </b-list-group-item>
          </b-list-group>
        </ul>
      </div>

      <div id="approved-events" v-if="approvedEvents.length">
        <h2>Approved</h2>
        <ul>
          <b-list-group v-for="item in approvedEvents" :key="item.title">
            <b-list-group-item>
              <div class="d-flex justify-content-between align-items-center">
                <strong>{{ item.title }}</strong>
                <b-button variant="danger" @click="deleteEvent(item.id)">Delete</b-button>
              </div>
              <p v-if="item.location">Location: {{ item.location }}</p>
              <p v-if="item.start">Start Date: {{ (item.start) | moment("dddd, MMMM Do YYYY") }}</p>
              <p v-if="item.start">Start Time: {{ (item.start) | moment("h:mm A") }}</p>
              <p v-if="item.end">End Date: {{ (item.end) | moment("dddd, MMMM Do YYYY") }}</p>
              <p v-if="item.end">End Time: {{ (item.end) | moment("h:mm A") }}</p>
              <p v-if="item.description">Description: {{ item.description }}</p>
              <p v-if="item.link">Event Link: <a :href="item.link">{{ item.link }}</a></p>
              <p v-if="item.name">Contact Name: {{ item.name }}</p>
              <p v-if="item.email">Contact Email: {{ item.email }}</p>
            </b-list-group-item>
          </b-list-group>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import GoogleLogin from 'vue-google-login';
import Vue from 'vue';

export default {
  components: {
    GoogleLogin,

  },
  data() {
    return {
      isSignedIn: false,
      isAuthorizedUser: false,
      currentUser: undefined,
      database: undefined,
      needApproval: [],
      approvedEvents: [],
      params: {
        client_id: '119500012444-8ft7vemlrobdue1t2p765h95hggnuh5l.apps.googleusercontent.com',
      },
      // only needed if you want to render the button with the google ui
      renderParams: {
        width: 250,
        height: 50,
        longtitle: true,
      },
    };
  },
  mounted() {
    this.database = firebase.firestore();
    this.refreshEvents();
    this.checkAuthStatus();
  },
  methods: {
    deleteEvent(id) {
      this.database.collection('calendars').doc(this.$route.params.calendar).collection('events')
        .doc(id)
        .delete()
        .then(() => {
          console.log('Event successfully deleted!');
          this.refreshEvents();
        })
        .catch((error) => {
          console.error('Error removing event: ', error);
        });
    },
    approveEvent(id) {
      const eventRef = this.database.collection('calendars').doc(this.$route.params.calendar).collection('events')
        .doc(id);

      eventRef.set({
        approved: true,
      }, { merge: true }).then(() => {
        console.log('Event approved successfully!');
        this.refreshEvents();
      }).catch((error) => {
        console.error('Error approving event: ', error);
      });
    },
    refreshEvents() {
      this.database.collection('calendars').doc(this.$route.params.calendar).collection('events').get()
        .then((querySnapshot) => {
          this.needApproval = [];
          this.approvedEvents = [];
          querySnapshot.forEach((doc) => {
            const event = doc.data();
            const eventObj = {
              ...event,
              id: doc.id,
              start: event.start.toDate(),
              end: event.end.toDate(),
              url: `#${this.$router.currentRoute.path}/${doc.id}`,
            };
            if (event.approved) {
              this.approvedEvents.push(eventObj);
            } else {
              this.needApproval.push(eventObj);
            }
          });
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
    },
    onReset(evt) {
      evt.preventDefault();
    },
    onSuccess(googleUser) {
      console.log(googleUser);

      // This only gets the user information: id, name, imageUrl and email
      console.log(googleUser.getBasicProfile());

      Vue.GoogleAuth.then((auth2) => {
        console.log(auth2.isSignedIn.get());
        console.log(auth2.currentUser.get());
      });
    },
    onFailure(err) {
      console.log('Failure!', err);
    },
    checkAuthStatus() {
      Vue.GoogleAuth.then((auth2) => {
        this.isSignedIn = auth2.isSignedIn.get();
        this.currentUser = auth2.currentUser.get().getBasicProfile();
        this.isAuthorizedUser = this.isSignedIn && (this.currentUser.getEmail() === 'pratik.vaidya425@gmail.com' || this.currentUser.getEmail() === 'reecekilbey7@gmail.com');
      });
    },
  },
};

</script>

<style lang='scss'>

</style>
